<template lang="pug">
  .report
    .flex
      label.fs-17(style="font-weight: bold; grid-column: 1/3; margin-bottom: 10px") opções
      PCheckbox(v-model="reportOptions.compensateWho" label="Não considerar horas que estão no banco de horas")
      .options
        .option
          span(style="font-weight: bold;") ordernar por:
          PRadio(label="nome", v-model="reportOptions.orderBy", option="name")
          PRadio(label="métricas", v-model="reportOptions.orderBy", option="metrics")
        .option
          span(style="font-weight: bold;") tipo de relatório:
          PRadio(label="soma", v-model="reportOptions.typeReport", option="sum")
          PRadio(label="por dia", v-model="reportOptions.typeReport", option="byday")
        .option
          span(style="font-weight: bold;") apresentação:
          PRadio(label="decimal", v-model="reportOptions.formatResult", option="decimal")
          PRadio(label="hora e minuto", v-model="reportOptions.formatResult", option="time")
        .option
          span(style="font-weight: bold;") mostrar:
          PRadio(label="local de trabalho cadastrado", v-model="reportOptions.calcBy", option="empCompany")
          PRadio(label="posto trabalhado", v-model="reportOptions.calcBy", option="lineCompany")

    Accordion(:startOpen="true")
      template(slot="heading")
        span.fs-19(style="text-align: center;") filtros
      template
        .filters
          .filter(v-for="(filter, index) in reportFilters" v-if="checkOnly(filter)")
            PCheckbox(v-model="reportFilters[index].checked" :label="filter.name")
            PSelect(
              v-if="filter.checked"
              v-model="filter.condition"
              name="condition"
              labelItem="name"
              :allowEmpty="false"
              title=""
              :openDirection="index > 11 ?  'above' : 'below'"
            )
            template(v-if="filter.checked")
              PInputHourMinute(
                v-if="filter.condition.selected.id !== 'interval'"
                label=""
                name="duration"
                v-model="filter.value"
              )
              template(v-else)
                PInputHourMinute(
                  v-model="filter.interval.start"
                  label="Início"
                  name="start"
                )
                PInputHourMinute(
                  v-model="filter.interval.end"
                  label="Fim"
                  name="end"
                )
            template(v-if="filter.checked && filter.customOptions")
              .custom-option(v-for="option in reportFilters[index].customOptions")
                PCheckbox(v-model="option.value" :label="option.name")

    .button
      PButton(color="success" size="md" @click="generate" :loading="loading" :disabled="!valid") gerar excel
</template>

<script>
import moment from 'moment'

export default {
  props: {
    reportInfo: {type: Object},
    valid: {type: Boolean}
  },
  data () {
    return {
      loading: false,
      reportFilters: [],
      reportOptions: {
        compensateWho: false,
        orderBy: 'name',
        typeReport: 'sum',
        formatResult: 'decimal',
        calcBy: 'empCompany'
      }
    }
  },
  computed: {
    entity () {
      if (this.reportInfo.entity === 'employees') return 'employee'
      return this.reportInfo.entity
    }
  },
  async created () {
    const result = await this.$API.R06.get({})
    const filterKeys = Object.keys(result.body.success)

    const conditionOptions = [
      {id: '=', name: 'igual a'},
      {id: '>', name: 'maior que'},
      {id: '<', name: 'menor que'},
      {id: 'interval', name: 'intervalo'}
    ]

    this.reportFilters = filterKeys.reduce((acc, filterId) => {
      function isNotCustom (id) {
        const isCustom = ['Custom. 1.', 'Custom. 2.', 'Custom. 3.'].includes(result.body.success[id])
        return !isCustom
      }

      if (filterId === 'showTotalHrs') {
        acc.push({
          id: filterId,
          name: result.body.success[filterId],
          checked: false,
          condition: {loaded: conditionOptions, selected: conditionOptions[0]},
          value: {hours: null, minutes: null, float: 0},
          useInterval: true,
          interval: {
            start: {hours: null, minutes: null, float: 0},
            end: {hours: null, minutes: null, float: 0}
          },
          customOptions: [
            {
              name: 'Sem intervalos',
              id: 'no_interval',
              value: false
            },
            {
              name: 'Sem adc. noturno',
              value: false,
              id: 'no_night_hours'
            }
          ]
        })
      } else if (isNotCustom(filterId)) {
        acc.push({
          id: filterId,
          name: result.body.success[filterId],
          checked: false,
          condition: {loaded: conditionOptions.filter(c => c.id !== 'interval'), selected: conditionOptions[0]},
          value: {hours: null, minutes: null, float: 0}
        })
      }

      return acc
    }, [])

    this.reportFilters.push(
      {
        id: 'pause_duration',
        name: 'Duração da Pausa',
        checked: false,
        condition: {loaded: conditionOptions, selected: conditionOptions[1]},
        value: {hours: null, minutes: null, float: 0},
        useInterval: true,
        interval: {
          start: {hours: null, minutes: null, float: 0},
          end: {hours: null, minutes: null, float: 0}
        },
        special: true
      },
      {
        id: 'all_extra_time_total',
        name: 'Horas Extra Totais',
        checked: false,
        condition: {loaded: conditionOptions.filter(c => c.id !== 'interval'), selected: conditionOptions[1]},
        value: {hours: null, minutes: null, float: 0},
        special: true,
        customOptions: [{name: 'Mostrar total', id: 'show_total', value: false}]
      },
      {
        id: 'fake_interjourney',
        name: 'Interjornada entre folga',
        checked: false,
        condition: {loaded: conditionOptions.filter(c => c.id !== 'interval'), selected: conditionOptions[2]},
        value: {hours: null, minutes: null, float: 0},
        special: true,
        only: 'byday'
      }
    )
  },
  methods: {
    async generate () {
      this.loading = true

      function format (filter) {
        const formatedFilter = {...filter}

        formatedFilter.condition = filter.condition.selected.id
        formatedFilter.value = filter.value.float

        formatedFilter.customOptions = filter.customOptions
          ? filter.customOptions.filter(o => o.value).map(o => o.id)
          : []

        if (filter.useInterval && filter.condition.selected.id === 'interval') {
          const {start, end} = filter.interval
          formatedFilter.interval.start = start.float
          formatedFilter.interval.end = end.float
        }

        return formatedFilter
      }

      const filter = this.reportFilters
        .filter(f => f.checked && f.special === undefined)
        .map(format)

      const specialFilter = this.reportFilters
        .filter(f => f.checked && f.special)
        .map(format)

      let result

      try {
        result = await this.$API.R06.save({
          entity: this.entity,
          entityContent: this.reportInfo.entityContent.map(i => i.id),
          ...this.reportOptions,
          filter,
          specialFilter,
          startDate: moment(this.reportInfo.periodData.startDate).format('MM-DD-YY'),
          endDate: moment(this.reportInfo.periodData.endDate).format('MM-DD-YY')
        })
      } catch (e) {
        result = e
      }
      this.$emit('handleReport', result)

      this.loading = false
    },
    checkOnly (f) {
      if (f.only === undefined) return true
      return f.only === this.reportOptions.typeReport
    }
  }
}
</script>

<style scoped lang="scss">
.report {
  display: grid;
  grid-row-gap: 10px;

  .flex {
    display: grid;
    grid-template-columns: .7fr 1fr;
    align-items: start;
    grid-column-gap: 20px;
    .options {
      display: grid;
      grid-auto-flow: row;
      .option {
        display: grid;
        grid-template-columns: 120px 200px 180px;
      }
    }
  }
  .filters {
    display: grid;
    grid-template-columns: 1fr;
    .filter {
      display: grid;
      grid-template-columns: 160px 100px 100px 100px 150px;
      align-items: end;
      grid-column-gap: 10px;
    }
  }
  .button {
    justify-self: end;
    margin-bottom: 50px;
  }
}
</style>
